import { CloseOutlined, EditOutlined, SaveOutlined } from '@ant-design/icons';
import { Button, DatePicker, message, Tooltip } from 'antd';
import moment, { Moment } from 'moment';
import React, { useEffect, useState } from 'react';

import { fetchAPI } from '../../../utils/api';
import { OrderItemV2 } from './types';

const OrderItemDeliveryDate = (props: {
  record: OrderItemV2;
  onSuccess: (silent?: boolean) => void;
}) => {
  const [editing, setEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deliveryDate, setDeliveryDate] = useState<Moment>(null);

  const saveDeliveryDate = async () => {
    setLoading(true);
    try {
      await fetchAPI(`order/item/${props.record.id}/delivery-date`, {
        method: 'PATCH',
        payload: {
          expected_delivery_date: deliveryDate.format('YYYY-MM-DD'),
        },
      });
      message.success('Expected delivery date updated!');
      setEditing(false);
      props.onSuccess(true);
    } catch (error) {
      message.error('Failed');
    }
    setLoading(false);
  };

  useEffect(() => {
    setDeliveryDate(
      props.record.expected_delivery_date
        ? moment(props.record.expected_delivery_date)
        : null
    );
  }, [props.record.expected_delivery_date, props.record.id]);

  if (editing) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: '5px',
          fontSize: '12px',
        }}
      >
        <DatePicker
          value={deliveryDate}
          onChange={dateMoment => setDeliveryDate(dateMoment)}
          disabled={loading}
          size="small"
          style={{ fontSize: 10, marginBottom: 10 }}
          format={'DD MMM YYYY'}
        />
        <div>
          <Button
            onClick={() => {
              if (props.record.expected_delivery_date) {
                setDeliveryDate(moment(props.record.expected_delivery_date));
              } else {
                setDeliveryDate(null);
              }
              setEditing(false);
            }}
            disabled={loading}
            icon={<CloseOutlined />}
            size="small"
            style={{ fontSize: 10, marginRight: 10 }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => saveDeliveryDate()}
            type="primary"
            loading={loading}
            icon={<SaveOutlined />}
            size="small"
            style={{ fontSize: 10 }}
            disabled={!deliveryDate}
          >
            Save
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        marginTop: '5px',
        fontSize: '12px',
      }}
    >
      <span>Expected Delivery Date :</span>
      <span>
        <b>{deliveryDate ? deliveryDate.format('DD MMM YYYY') : '-'}</b>{' '}
        <Tooltip title="Edit Expected Delivery Date">
          <EditOutlined
            onClick={() => {
              if (props.record.expected_delivery_date) {
                setDeliveryDate(moment(props.record.expected_delivery_date));
              } else {
                setDeliveryDate(null);
              }
              setEditing(true);
            }}
          />
        </Tooltip>
      </span>
    </div>
  );
};

export default OrderItemDeliveryDate;
